__turbopack_context__.v({
  "allowAccordion": "TitleCell-module__mRdxtW__allowAccordion",
  "assetIcon": "TitleCell-module__mRdxtW__assetIcon",
  "badge": "TitleCell-module__mRdxtW__badge",
  "badgeInline": "TitleCell-module__mRdxtW__badgeInline",
  "caretClosed": "TitleCell-module__mRdxtW__caretClosed",
  "caretIcon": "TitleCell-module__mRdxtW__caretIcon",
  "caretOpen": "TitleCell-module__mRdxtW__caretOpen",
  "clickable": "TitleCell-module__mRdxtW__clickable",
  "description": "TitleCell-module__mRdxtW__description",
  "folderZapTableRowTitle": "TitleCell-module__mRdxtW__folderZapTableRowTitle",
  "icon": "TitleCell-module__mRdxtW__icon",
  "root": "TitleCell-module__mRdxtW__root",
  "serviceIcon": "TitleCell-module__mRdxtW__serviceIcon",
  "subtitleIcon": "TitleCell-module__mRdxtW__subtitleIcon",
  "subtitleRow": "TitleCell-module__mRdxtW__subtitleRow",
  "subtitleWrapper": "TitleCell-module__mRdxtW__subtitleWrapper",
  "title": "TitleCell-module__mRdxtW__title",
  "titleLink": "TitleCell-module__mRdxtW__titleLink",
  "titleLinkContainer": "TitleCell-module__mRdxtW__titleLinkContainer",
  "titleLinkDefault": "TitleCell-module__mRdxtW__titleLinkDefault",
  "titleLinkInline": "TitleCell-module__mRdxtW__titleLinkInline",
});
